/** Sends a single camera setting change to the camera service (same endpoint as Device Config). */
export const updateDeviceField = async (deviceId: string, field: string, value: string | number | boolean) => {
  const apiValue = typeof value === "boolean" ? (value ? 1 : 0) : value;
  const params = new URLSearchParams();
  params.append("deviceID", deviceId);
  params.append("field", field);
  params.append("value", apiValue.toString());
  const res = await fetch("https://i56o7w.buildship.run/updateDevice", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: params,
  });
  if (!res.ok) throw new Error("Failed to update device");
  return apiValue.toString();
};
